import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=0bc4212e&"
import script from "./MainView.vue?vue&type=script&lang=js&"
export * from "./MainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gantt-elastic/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc4212e')) {
      api.createRecord('0bc4212e', component.options)
    } else {
      api.reload('0bc4212e', component.options)
    }
    module.hot.accept("./MainView.vue?vue&type=template&id=0bc4212e&", function () {
      api.rerender('0bc4212e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainView.vue"
export default component.exports